import React from "react";

export default function Footer() {
  return (
    <footer className="auth-footer mt-5"> © 2018 All Rights Reserved.</footer>
  );
}
